export type Difficulty = 'easy' | 'medium' | 'hard' | 'narco';

export interface DifficultyProfile {
  label: string;
  thinkingTimeMs: [number, number];
  targetDragSecs: [number, number];
  combosPerTurn: [number, number];
  chokeMeterCeiling: number;
  jointAvoidanceMargin: number;
  comboWindowDelayMs: [number, number];
  reactionMs: number;
  /** Probability that the bot will even attempt a QTE when one arms. 1.0 for narco (planner). */
  qteAttemptPct: number;
  /** Gaussian stddev (ms) applied to the bot's release time around the golden-zone center. */
  qteAimJitterMs: number;
}

export const DIFFICULTIES: Record<Difficulty, DifficultyProfile> = {
  easy: {
    label: 'EASY',
    thinkingTimeMs: [800, 1600],
    targetDragSecs: [1.0, 2.0],
    combosPerTurn: [1, 1],
    chokeMeterCeiling: 30,
    jointAvoidanceMargin: 25,
    comboWindowDelayMs: [1800, 2300],
    reactionMs: 250,
    qteAttemptPct: 0.25,
    qteAimJitterMs: 180
  },
  medium: {
    label: 'MEDIUM',
    thinkingTimeMs: [500, 1100],
    targetDragSecs: [2.0, 4.0],
    combosPerTurn: [1, 2],
    chokeMeterCeiling: 60,
    jointAvoidanceMargin: 15,
    comboWindowDelayMs: [800, 1600],
    reactionMs: 180,
    qteAttemptPct: 0.50,
    qteAimJitterMs: 110
  },
  hard: {
    label: 'HARD',
    thinkingTimeMs: [300, 700],
    targetDragSecs: [3.0, 6.0],
    combosPerTurn: [2, 4],
    chokeMeterCeiling: 85,
    jointAvoidanceMargin: 5,
    comboWindowDelayMs: [400, 900],
    reactionMs: 120,
    qteAttemptPct: 0.75,
    qteAimJitterMs: 60
  },
  narco: {
    // NarcoAIController runs its own planner and mostly ignores these tuning values.
    // It still reads `chokeMeterCeiling` and `jointAvoidanceMargin` as hard safety limits.
    label: 'NARCO',
    thinkingTimeMs: [80, 180],
    targetDragSecs: [3.0, 6.0],
    combosPerTurn: [4, 10],
    chokeMeterCeiling: 88,
    jointAvoidanceMargin: 3,
    comboWindowDelayMs: [150, 350],
    reactionMs: 40,
    qteAttemptPct: 1.00,
    qteAimJitterMs: 25
  }
};
